<template lang="pug">
  v-container#main
    v-carousel(
      continuous
      cycle
      hide-delimiter-background
      class="top-carousel"
      eager
      show-arrows-on-hover
    )
      v-carousel-item(
        v-for="(b,i) in banner_list"
        :key="i"
      )
        v-img(:src="b.banner_url" height="100%")
          v-layout(align-center justify-center fill-height slot="placeholder")
            v-progress-circular(indeterminate color="primary")
        .image-overlay
          v-btn(
            color="primary"
            block 
            depressed
          ) 
            v-icon mdi-magnify
            b.ml-2 {{ b.display_id }}
    v-container.home-container
      Category(
        class="d-lg-none"
        @switchCategory="switchCategory($event)"
      )
      List(:category="selectedCategory")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

import Category from "@/views/home/Category";
import List from "@/views/home/List";

export default {
  props: {
    category: String
  },
  watch: {
    category: {
      immediate: true,
      handler(val) {
        this.selectedCategory = val;
      }
    },
    type() {
      this.getBannerList();
    }
  },
  components: {
    Category,
    List
  },
  data() {
    return {
      value: 1,
      selectedCategory: "",
      banner_list: [],
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  computed: {
    type() {
      return this.$store.getters.businessType;
    }
  },
  mounted() {
    this.getBannerList();
    this.$store.commit("layout/setDisplayTitle", "");
  },
  methods: {
    switchCategory(e) {
      this.selectedCategory = e;
    },
    getBannerList() {
      let url = config.businessBannerUrl();

      var json = {
        params: {
          business_type: this.type,
          customer_id: this.$store.getters.customerId,
          customer_sessiontoken: this.$store.getters.sessionToken
        }
      };

      this.loading = true;

      this.$http
        .get(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.banner_list = response.body.data;
              } else {
                this.$swal(
                  this.$t("error.get_business_banner"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.get_business_banner"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.get_business_banner"),
            response.body.message,
            "error"
          );
        });
    }
  }
};
</script>
